import { Actions } from '../../interfaces'
import { ComponentValue } from '@/entities/vehicle'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { ComponentValue },
  actions: { [ComponentValue.name]: actions },
}
